import React, { useEffect, useMemo, useRef } from 'react'
import { useUpdate } from 'react-use'
// @ts-expect-error — non typed; TODO: is this needed?
import moment from 'moment/min/moment-with-locales'

import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import { useInterval } from '../../../sharedLegacy/hooks'

interface CountdownComponentProps {
  timestamp: number
  onCountdownZero?: () => void
}

const CountdownComponent = ({
  timestamp,
  onCountdownZero,
}: CountdownComponentProps) => {
  const { data: liveData } = useLiveDataQuery()

  const deadlineMoment = useMemo(() => {
    const d = moment.unix(timestamp)
    if (liveData?.locale) d.locale(liveData.locale)
    return d
  }, [timestamp, liveData?.locale])

  const update = useUpdate()
  useInterval(update, 1000)

  const duration = deadlineMoment.diff(moment(), 'seconds')

  const hasFiredRef = useRef(false)

  useEffect(() => {
    if (duration < 0 && !hasFiredRef.current) {
      onCountdownZero?.()
      hasFiredRef.current = true
    } else if (duration >= 0 && hasFiredRef.current) {
      hasFiredRef.current = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [duration])

  if (duration >= 86400) {
    return (
      <div className="countdown-component">{deadlineMoment.fromNow(true)}</div>
    )
  }

  if (duration >= 0) {
    const durationAsUTCTime = moment.utc(duration * 1000)
    return (
      <div className="countdown-component">
        <span>{durationAsUTCTime.format('HH:mm:ss')}</span>
      </div>
    )
  }

  return (
    <div className="countdown-component">{deadlineMoment.fromNow(true)}</div>
  )
}

export { CountdownComponent }
